
<template>
  <div class="home">
    <label class="text-reader">
      <label for="myfile">Hintergrund auswählen:</label>
      <input type="file"  id="myfile" name="myfile" @change="loadTextFromFile" />

    </label>
 <div id="wrapper">
      <div id="page-content">
        <img src="../assets/logo.png" id="2testimg" width="50" >
        <h1>Inhalt:</h1>

        <vue-draggable-resizable :w="100" :h="50"   :lock-aspect-ratio="true"  @dragging="onDrag" @resizing="onResize" :parent="false">
          <img src="../assets/Logo_Dolby_Atmos.svg" class="svg-drag-element">
        </vue-draggable-resizable>
      </div>

      <div id="imageholder" width="100"></div>
    </div>
    <button @click="createCanvas">create and SaveCanvas</button>
    <br>
    <div id="slider">
      <VueSlickCarousel v-bind="settings">
        <div  class="slideElement">1</div>
        <div  class="slideElement">2</div>
        <div  class="slideElement">3</div>
        <div  class="slideElement">4</div>
      </VueSlickCarousel>
    </div>

  </div>

</template>

<script>
/* eslint-disable */
// @ is an alias to /src
import 'file-saver'
import 'canvas-toBlob'
import 'html2canvas'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import VueDraggableResizable from 'vue-draggable-resizable'
export default {
  name: 'Home',
  components: {VueSlickCarousel
  },
  data: function(){
    return{
      canvasElement: null,
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      settings: {
        "dots": true,
        "dotsClass": "slick-dots custom-dot-class",
        "edgeFriction": 0.35,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 2,
        "slidesToScroll": 1,
        "rows" :2,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,

              "dots": true
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 2,
              "slidesToScroll": 2,
              "initialSlide": 2,
              "rows" :1,
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1
            }
          }
        ]
      },
    }
  },
  mounted() {
    // `this` points to the vm instance

    // var FileSaver = require('file-saver');
    // var blob = new Blob(["Hello, world!"], {type: "text/plain;charset=utf-8"});
    // FileSaver.saveAs(blob, "hello world.txt")
  /*
    this.canvasElement = document.getElementById('c1');
    var ctx = this.canvasElement.getContext('2d');
    const img1 = new Image();
    // onload event listener to process the image data after it was loaded
    img1.onload = () => {
      this.canvasElement.width = img1.width;
      this.canvasElement.height = img1.height;
      ctx.drawImage(img1, 0, 0);

      ctx.fillStyle = "rgba(100, 0, 0, 0.5)";
      ctx.fillRect(0, 0, img1.width, img1.height);

    };
    img1.src = document.getElementById("2testimg").src;
*/
  },
  methods: {
    loadTextFromFile(ev){
      const file = ev.target.files[0];
      const reader = new FileReader();

      reader.onload = e => this.imageHandler( e.target.result);
      reader.readAsDataURL(file);
    },
    imageHandler(e2)
    {
      console.log (e2)
      var store = document.getElementById('imageholder');
      store.innerHTML='<img src="' + e2 +'">';
    },
    saveCanvas(){
      this.canvasElement.toBlob(function(blob){
         saveAs(blob, "myImage.png");
      });
    },
    createCanvas(){

      var svgElements = document.body.querySelectorAll('svg');
      svgElements.forEach(function(item) {
        item.setAttribute("width", item.getBoundingClientRect().width);
        item.style.width = null;
      });
      html2canvas(document.getElementById('wrapper')).then(function(canvas) {
        //document.body.appendChild(canvas);
        canvas.toBlob(function(blob){

          saveAs(blob, "comic.png");
        });
      });
    },
    onResize: function (x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    },
    onDrag: function (x, y) {
      this.x = x
      this.y = y
    }
  }
}
</script>

<style>
  .text-reader {

  }
  .text-reader input {

  }
  #wrapper{
    background-color: black;
    position: relative;
    width: 800px;
    height: 500px;
    overflow: hidden;
  }
  #page-content{
    position: absolute;
    z-index: 10;
  }
  #imageholder{
    width: 100%;
    margin: 0 auto;
    position: absolute;
    top: 0;
    left:0;
    z-index: 1;
  }
  #imageholder img{
    width: 100%;
    height: auto;
  }

  .svg-drag-element{
    width: 100%;
    height: auto
  }
  .slideElement{


    background-color: red;
  }

</style>
